import React from 'react';
const comparisonRows = [{
  situation: 'Tu imagen profesional',
  without: 'Flyer hecho en el celular',
  with: 'Identidad visual premium coherente'
}, {
  situation: 'Protección legal',
  without: 'Contrato verbal (ninguna)',
  with: 'Kit completo de documentos firmados'
}, {
  situation: 'Cobranza',
  without: 'Incómoda e irregular',
  with: 'Sistema sin drama en 5 pasos'
}, {
  situation: 'Atracción de alumnos',
  without: 'Solo boca a boca',
  with: 'Boca a boca + redes + sistema activo'
}, {
  situation: 'El alumno que se va',
  without: 'Sin aviso, sin sistema',
  with: 'Sistema de fidelización que lo retiene'
}, {
  situation: 'Tu precio',
  without: 'El de mercado o menos',
  with: '30–50% sobre el mercado justificado'
}, {
  situation: 'Tu Instagram',
  without: 'Irregular, sin estrategia',
  with: '30 temas + sistema de contenidos'
}, {
  situation: 'Tu propuesta de valor',
  without: 'No la podés explicar',
  with: '1 oración que diferencia y vende'
}];
const blocks = [{
  icon: '🎯',
  title: 'Módulo 1 — Mentalidad Empresarial',
  desc: 'Diagnóstico financiero + el modelo de las 3 fuentes de ingreso + KPIs del estudio'
}, {
  icon: '💰',
  title: 'Módulo 2 — Ingeniería de Precios',
  desc: 'Sistema de 3 niveles de precio + escalera de valor + cómo comunicar aumentos'
}, {
  icon: '📱',
  title: 'Módulo 3 — Ventas y Conversión',
  desc: 'Script maestro de WhatsApp + cierre dentro de la primera clase + 7 scripts de seguimiento'
}, {
  icon: '📣',
  title: 'Módulo 4 — Marketing de Guerrilla',
  desc: 'Google My Business + Instagram sin estrés + 30 temas de contenido + boca a boca estructurado'
}, {
  icon: '⚙️',
  title: 'Módulo 5 — Automatización',
  desc: 'Mercado Pago suscripción + planilla maestra + protocolo de retención + recuperación de alumnos'
}, {
  icon: '🏔️',
  title: 'Módulo 6 — Escalar',
  desc: 'Sistema completo de retiros + matemática del retiro rentable + hoja de ruta de formaciones'
}, {
  icon: '📅',
  title: 'Módulo 7 — Plan de 12 Meses',
  desc: 'Hoja de ruta mensual con acciones concretas y metas financieras mes a mes'
}, {
  icon: '⚖️',
  title: 'Módulo 8 — Documentos Legales',
  desc: 'Ficha médica completa + deslinde de responsabilidad + recibos + presupuestos'
}];
export function EliteSection() {
  return <section className="w-full bg-[#1a0a2e] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🧘 ¿Qué agrega el{' '}
            <span className="text-[#B87AFF]" data-id="element-78">ESTUDIO PRO ELITE™</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto mb-2" data-id="element-79">
            Tu sistema de gestión, identidad y marketing profesional.
          </p>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-80">
            Porque el yoga que enseñás ya era extraordinario. Este sistema hace
            que el mundo lo sepa.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#B87AFF]/30 rounded-2xl overflow-hidden mb-12" data-id="element-81">
          {/* Header */}
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#0d0a1a] border-b border-[#B87AFF]/30" data-id="element-82">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-83">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#B87AFF]/30" data-id="element-84">
              Sin Estudio Pro Elite
            </div>
            <div className="p-4 font-bold text-[#B87AFF] text-center border-l border-[#B87AFF]/30" data-id="element-85">
              Con Estudio Pro Elite
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-1 sm:grid-cols-3${i < comparisonRows.length - 1 ? ' border-b border-gray-800' : ''}`} data-id="element-86">
              <div className="p-4 text-white text-sm sm:text-base" data-id="element-87">
                <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-88">
                  Situación:
                </span>
                {row.situation}
              </div>
              <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-89">
                <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-90">
                  Sin Estudio Pro Elite:
                </span>
                {row.without}
              </div>
              <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#B87AFF]/5" data-id="element-91">
                <span className="sm:hidden font-bold text-[#B87AFF] block mb-1" data-id="element-92">
                  Con Estudio Pro Elite:
                </span>
                {row.with}
              </div>
            </div>)}
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-93">
          ✅ ESTUDIO PRO ELITE™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-94">
          {blocks.map(block => <div key={block.title} className="bg-black border border-[#B87AFF]/20 rounded-xl p-5" data-id="element-95">
              <h4 className="text-[#B87AFF] font-bold text-lg mb-2" data-id="element-96">
                {block.icon} {block.title}
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-97">{block.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}